// extracted by mini-css-extract-plugin
export default {"wrapper":"MadeIactivePro_wrapper__tIeTH","made":"MadeIactivePro_made__wi6DV"};